import React, { useState } from 'react'

import { Button, Divider, Form, Input, InputNumber, Typography } from 'antd';
import { Navigate, useNavigate } from 'react-router-dom';

import { useHideMenu } from '../hooks/useHideMenu';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage';


const { Title, Text } = Typography


export const Ingresar = () => {

    const navigate = useNavigate();

    const [usuario ] = useState( getUsuarioStorage() )

    useHideMenu(false);


    const onFinish = ({ agente, modulo}) => {
        
        localStorage.setItem('agente', agente);
        localStorage.setItem('modulo', modulo);
        
        navigate('/escritorio');
    };
      
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    if( usuario.agente && usuario.modulo ) {
        return <Navigate to="/escritorio" />
    }

  return (
   
    <>
        <Title level={2}>Ingresar</Title>
        <Text>Ingrese su Nombre y número de módulo</Text>
        <Divider />
        <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            
        >
            <Form.Item
                label="Nombre de Agente"
                name="agente"
                rules={[{ required: true, message: 'Ingrese su nombre!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Módulo"
                name="modulo"
                rules={[{ required: true, message: 'Ingrese el Número de Módulo!' }]}
            >
                <InputNumber min={ 1 } max={ 99 } />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button 
                    type="primary" 
                    htmlType="submit"
                    shape='round'>
                    Submit
                </Button>
            </Form.Item>
        </Form>
    </>
    
  )
}
